import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '730px',
    minWidth: '299px',
    width: '100%',
    alignSelf: 'center',
    marginBottom: '90px',
  },
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '23px',
    },
    fontSize: '33px',
    fontWeight: '400',
    color: '#fff',
    marginBottom: '35px',
  },
  section: {
    marginBottom: '20px',
  },
  stepHeader: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
    fontSize: '16px',
    marginBottom: '20px',
    color: '#fff',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
  },
  noMargin: {
    margin: '0',
  },
  stepHeaderChecked: {
    width: '19px',
    height: '18px',
    marginRight: '9px',
  },
  stepHeaderNum: {
    marginRight: '9px',
    fontSize: '13px',
    borderRadius: '50%',
    border: '2px solid #fff',
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '2px',
  },
  tooltipImg: {
    [theme.breakpoints.down('xs')]: {
      marginLeft: '7px',
      width: '16px',
    },
    margin: '0 10px',
    width: '20px',
  },
  dragAndDropContainer: {
    width: '100%',
    height: '76px',
    display: 'inline-flex',
    '&:hover': {
      '& $selectModelButton': {
        borderColor: '#fff',
      },
      '& $dragAndDropText': {
        color: '#fff',
      },
    },
    border: '1px solid #404040',
    borderRadius: '8px',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#292929',
  },
  dragAndDropText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px',
      lineHeight: '14px',
    },
    fontWeight: '300',
    fontSize: '16px',
    color: '#ffffff',
    textAlign: 'center',
    lineHeight: '19px',
  },
  addButtonImg: {
    [theme.breakpoints.down('xs')]: {
      width: '17px',
      height: '17px',
      marginRight: '5px',
    },
    width: '25px',
    height: '25px',
    marginRight: '10px',
  },
  dragAndDropList: {
    paddingTop: '10px !important',
    paddingBottom: '0!important',
  },
  listItem: {
    paddingTop: 0,
    paddingBottom: 0,
    height: '35px',
  },
  listItemAvatar: {
    [theme.breakpoints.down('xs')]: {
      minWidth: '30px',
    },
    minWidth: '40px',
  },
  avatar: {
    [theme.breakpoints.down('xs')]: {
      width: '20px',
      height: '20px',
    },
    width: '23px',
    height: '23px',
  },
  audioIcon: {
    [theme.breakpoints.down('xs')]: {
      width: '15px',
      height: '15px',
    },
    width: '18px',
    height: '18px',
  },
  listItemText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px!important',
      maxWidth: '165px',
    },
    fontSize: '14px!important',
    color: '#fff',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  durationText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    color: '#fff',
    fontSize: '15px',
    fontWeight: '300',
    paddingTop: '10px',
    paddingBottom: '5px',
  },
  labelInput: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px !important',
    },
    fontSize: '16px !important',
    padding: '0 8px',
    width: '100%',
    height: '36px',
    color: '#9a9a9a',
    padding: '18px 10px',
    backgroundColor: '#292929',
    border: '1px solid #9A9A9A',
    borderRadius: '8px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  submitContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    [theme.breakpoints.down('xs')]: {
      padding: '10px 15px',
      fontSize: '11px',
      minWidth: '100px',
    },
    backgroundColor: '#CAFF73',
    padding: '10px 30px',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    minWidth: '120px',
    cursor: 'pointer',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  loadingText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    fontSize: '16px',
    marginLeft: '16px',
    lineHeight: '22px',
    color: '#fff',
    fontWeight: '300',
  },
  dragAndDrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  separater: {
    borderBottomWidth: '1px',
    borderBottomColor: '#686868',
    borderBottomStyle: 'solid',
    margin: '1.5rem 0',
  },
  noMargin: {
    margin: '0',
  },
  greyout: {
    color: '#888888',
    '& $stepHeaderNum': {
      border: '2px solid #888888',
    },
  },
  disabledButton: {
    backgroundColor: '#A4A4A4!important',
    cursor: 'not-allowed',
  },
  progressButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '10px 10px 10px 15px',
      fontSize: '11px',
      minWidth: '95px',
    },
    backgroundColor: '#A4A4A4!important',
    padding: '10px 20px 10px 30px',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    minWidth: '120px',
    cursor: 'not-allowed',
    display: 'flex',
  },
  loadingCircle: {
    [theme.breakpoints.down('xs')]: {
      width: '11px!important',
      height: '11px!important',
      marginLeft: '5px',
    },
    marginLeft: '5px',
    width: '15px!important',
    height: '15px!important',
  },
}));

export { useStyles };
